import { useContext } from 'react'
import { BreadcrumbsContext, BreadcrumbsContextType } from './Breadcrumbs.context'

export default function useBreadcrumbs(): BreadcrumbsContextType {
  const context = useContext(BreadcrumbsContext)

  if (context === undefined) {
    throw new Error('useBreadcrumbs must be used within a BreadcrumbsContextProvider')
  }

  return context
}
